<template lang="pug">
v-card(:loading="busy")

  pagelet-action-bar(
    v-bind="$props"
    @refresh="refresh"
    @perform="opts => $emit('perform', opts)"
    :allow-refresh="!!sourceEref"
  )

  v-data-table.x-data-table.px-0(
    :headers="headers"
    :items="items"
    :class="{ 'pt-2': hideActionBar }"
    dense
    fixed-header
    calculate-widths
    disable-filtering
    disable-sort
    disable-pagination
    hide-default-footer
  )
</template>

<style>
.x-data-table caption {
  padding: 4px;
  padding-left: 16px;
  text-align: left;
}
</style>

<script>
import PageletActionBar from './-parts/PageletActionBar'

export default {

  components: {
    PageletActionBar,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,   // @type {Keep.Paper.Design.Entity}
    pagelet: Object,  // @type {Keep.Paper.Design.Entity}

    hideActionBar: Boolean,
  },

  data: () => ({
    busy: false,
  }),

  computed: {
    sourceEref: vm => vm.pagelet?.dataSet?.eref || vm.pagelet?.dataSet?.see,

    dataSet: vm => vm.pagelet?.dataSet || vm.entity.dataSet || {},
    sets: vm => vm.dataSet.sets || [],

    // TODO: Deveria haver suporte à SET nomeado. Por ora pegamos o primeiro...
    set: vm => vm.sets[0] || {},
    rows: vm => vm.set.rows || [],

    items: vm => vm.rows.map(row => {
      const item = {}
      const entries = Object.entries(row)
      entries.forEach(([key, value]) => item[key] = (value?.value || value))
      return item
    }),

    headers() {
      const sample = this.items[0]
      if (!sample) return []
      const keys = Object.keys(sample)
      return keys.map(key => ({ text: key, value: key }))
    },

    caption() {
      return this.hideActionBar ? null : this.pagelet?.title
    },
  },

  methods: {
    // perform() {
    // },

    refresh() {
      const { form, data } = this
      this.restore()
    },

    async restore() {
      if (this.busy) return
      try {
        // Sincronizando a entidade...
        this.busy = true

        const { sourceEref: eref } = this
        const link = { eref }

        // Realizando a cosulta...
        const status = await this.$resolve(link)
        if (!status.ok)
          return

        const { entity: dataSet } = status
        if (dataSet.eref !== eref)
          return

        this.entity.dataSet = dataSet

        // if (entity.see) {
        //   const { site, see : eref } = entity
        //   this.$router.push({ route: 'Workspace', params: { site, eref }})
        //   return
        // }

        // if (dataSetOnly && entity && this.entity) {

        //   // Atualizando o dataSet da entidade atual...
        //   this.$set(this.entity, 'dataSet', entity.dataSet)

        //   if (storeLater) {
        //     this.$store.commit(STORE_ENTITY, this.entity);
        //   }
        // }

      } finally {
        this.busy = false
      }
    },
  },
}
</script>